import React from 'react';

import AccountPlanContainer from '@totem/components/accountPlan/AccountPlanContainer';
import AccountPlanLayout, {
  AccountPlanExtra,
} from '@totem/components/accountPlan/AccountPlanLayout';
import IBCard from '@totem/components/ui_components/antDesignOverrides/IBCard';
import ContentLayout from '@totem/components/ui_components/page/ContentLayout';

const AccountPlanPage = () => (
  <ContentLayout>
    <AccountPlanContainer>
      <IBCard isCovered title="Account Plan" extra={<AccountPlanExtra />}>
        <AccountPlanLayout />
      </IBCard>
    </AccountPlanContainer>
  </ContentLayout>
);

export default AccountPlanPage;
